<div class="wrapper">
  <!-- start .row -->
  <div class="row">
    <div class="col-sm-12 wtw-hero-image">
      <img id="BGprincipal" class="img-responsive"
        src="./assets/global/images/cabeceras/bg_admin_parametricas.jpg">
      <h1 class="wtw-bg-black col-lg-5" style="margin-left: 15px">Administración</h1>
    </div>
  </div>
  <!-- end .row -->

  <div class="container-fluid">

    <!-- Page-Title -->
    <div class="row">
      <div class="col-sm-12">
        <div class="page-title-box">
          <div class="btn-group pull-right">
            <ol class="breadcrumb hide-phone p-0 m-0">
              <li class="breadcrumb-item"><a href="#">Inicio</a></li>
              <li class="breadcrumb-item"><a href="#">Administración</a></li>
              <li class="breadcrumb-item"><a href="#">Paramétricas</a></li>
              <li class="breadcrumb-item"><a href="#">UEN</a></li>
            </ol>
          </div>
          <h4 class="page-title">Administración Paramétricas</h4>
        </div>
      </div>
    </div>
    <!-- end page title end breadcrumb -->

    <div class="row">
      <div class="col-12">
        <div class="card-box table-responsive">
          <h4 class="header-title mb-3">Información UEN</h4>
          <div id="key-table_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
            <div class="row">
              <div class="actions clearfix">
                <button type="button" class="btn btn-primary waves-effect waves-light"
                  (click)="updateUen()">{{"configuracion.parametricas.uen.botones.actualizarUen" | translate}}</button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div style="position: absolute; height: 1px; width: 0px; overflow: hidden;"><input type="text"
                    tabindex="0"></div>
                <table class="table table-hover m-0  dt-responsive nowrap" cellspacing="0" width="100%" id="datatable">
                  <thead>
                    <tr>
                      <th>{{"configuracion.parametricas.uen.tablaUen.codigo" | translate}}</th>
                      <th>{{"configuracion.parametricas.uen.tablaUen.nombre" | translate}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of ListUEN">
                      <td>{{item.codigo}}</td>
                      <td>{{item.nombre}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 
      <div class="row">
          <div class="col-12">
              <div class="card-box table-responsive">
                  <h4 class="m-t-0 header-title">Información Regionales</h4>
                  <div class="actions clearfix">
                      <button type="button" class="btn btn-primary waves-effect waves-light" (click)="updateRegional()">{{"configuracion.parametricas.regionales.botones.actualizarRegional"
                          | translate}}</button>
                  </div>
                  <div id="key-table_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                      <div class="row">
                          <div class="col-sm-12">
                              <div style="position: absolute; height: 1px; width: 0px; overflow: hidden;"><input type="text"
                                      tabindex="0"></div>
                              <table class="table table-hover m-0 dt-responsive nowrap" width="100%" *ngIf="regionalService.listRegional && regionalService.listRegional.length">
                                  <thead>
                                      <tr>
                                          <th>{{"configuracion.parametricas.regionales.tablaRegional.codigo" |
                                              translate}}</th>
                                          <th>{{"configuracion.parametricas.regionales.tablaRegional.nombre" |
                                              translate}}</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr *ngFor="let item of regionalService.listRegional">
                                          <td>{{item.codigo}}</td>
                                          <td>{{item.nombre}}</td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div> -->

  </div> <!-- end container -->
</div>
<!-- end wrapper -->
<div class="blanco"></div>

<!--   
<div class="wrapper">
<button (click)="updateUen()" class="btn btn-primary">{{"configuracion.parametricas.uen.botones.actualizarUen" | translate}}</button>
<table class="table table-bordered table-striped" *ngIf="uenService.listUen && uenService.listUen.length">
  <thead>
    <tr>
      <th>{{"configuracion.parametricas.uen.tablaUen.codigo" | translate}}</th>
      <th>{{"configuracion.parametricas.uen.tablaUen.nombre" | translate}}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of uenService.listUen">
      <td>{{item.codigo}}</td>
      <td>{{item.nombre}}</td>
    </tr>
  </tbody>
</table>
</div> -->
